import React from 'react'
import { BulkDeleteWithConfirmButton, Datagrid } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import Exporter from 'services/csv/exporter'
import ReorderableList from 'ui-shared/DraggableList/ReorderableList'
import LocalizedTextField from 'ui-shared/LocalizedFields/LocalizedTextField'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const LogisticsList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper>
      <ReorderableList
        {...props}
        pagination={false}
        bulkActionButtons={
          <BulkDeleteWithConfirmButton mutationMode="optimistic" />
        }
        exporter={Exporter()}
      >
        <Datagrid rowClick="edit">
          <LocalizedTextField source="name" sortable={false} />
        </Datagrid>
      </ReorderableList>
    </SectionWrapper>
  )
}

export default LogisticsList
